import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import InlineList from 'components/InlineList';
import { TeamPill } from 'components/Pill';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import { useFormFieldContext } from 'components/FormField/FormFieldContext';
import useUniqueId from 'hooks/useUniqueId';
function TeamsList(_ref) {
  var teams = _ref.teams,
    onRemoveTeam = _ref.onRemoveTeam,
    title = _ref.title,
    description = _ref.description;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var titleId = useUniqueId();
  if (title) {
    return /*#__PURE__*/React.createElement(Stack, {
      spacing: "xs",
      role: "group",
      "aria-labelledby": titleId
    }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Text, {
      id: titleId
    }, title), /*#__PURE__*/React.createElement(HintTooltip, {
      content: description,
      spacingLeft: "xs",
      vAlign: false
    })), /*#__PURE__*/React.createElement(InlineList, {
      spacing: "xxs",
      "aria-labelledby": labelId
    }, teams.map(function (team) {
      var id = team.id;
      return /*#__PURE__*/React.createElement(TeamPill, {
        key: id,
        team: team,
        onDelete: function onDelete() {
          return onRemoveTeam(id);
        },
        deleteLabel: t('actions_remove_team')
      });
    })));
  }
  return /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs",
    "aria-labelledby": labelId
  }, teams.map(function (team) {
    var id = team.id;
    return /*#__PURE__*/React.createElement(TeamPill, {
      key: id,
      team: team,
      onDelete: function onDelete() {
        return onRemoveTeam(id);
      },
      deleteLabel: t('actions_remove_team')
    });
  }));
}
export default TeamsList;